import { AddressBookRecord } from '@tassat/fred-definitions';

import { download, sanitizeCSVValue } from 'Lib/exportHelper';
import { formatEpochDate } from 'Lib/stringHelpers';
import ClientStore from 'Reducers/store/clientStore';
import { getAddressBookContactsArray } from 'Selectors/addressBook';

export const exportClientFirmAddressBook = () => {
    const state = ClientStore.getState();
    const contacts = getAddressBookContactsArray(state);

    let exportString = 'Firm Name,Account Name,Lynq Account Address,Account Nickname,Favorited,Modified At,Modified By\n';

    contacts.forEach((contact: AddressBookRecord) => {
        const updateTime = contact.UpdatedAt && contact.UpdatedAt !== '0' ? formatEpochDate(contact.UpdatedAt) : '';
        const contactAddress = `S${contact.Account.slice(2)}`;

        exportString += `"${sanitizeCSVValue(contact.FirmName)}","${sanitizeCSVValue(contact.AccountName)}","${contactAddress}","${sanitizeCSVValue(contact.NickName)}","${contact.IsFavorite}","${updateTime}","${sanitizeCSVValue(contact.ModifiedByUsername)}"\n`;
    });

    download('Lynq_Platform_Address_Book.csv', exportString);
};